import { request } from '@/libs/api-request'

export function getRemainJam (params, force) {
  const url = '/jam/get_count'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}
// 유효기간 1년 미만 잼
export function getExpireJamList (params, force) {
  const url = '/jam/get_remain_list_by_expire'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}
// 전체 잼 리스트
export function getJamList (params, force) {
  const url = '/jam/get_list'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}

export function getJamBasketList (params, force) {
  const url = '/jam/get_basket_list'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}
// 잼으로 PV 충전
export function onChargePvByJam (params, force) {
  const url = '/ba/credit/purchase_by_jam'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}

// 잼 충전
export function onChargeJam (params, force) {
  const url = '/jam/purchase'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}

export function getBaBasket (params, force) {
  const url = '/jam/get_ba_apply_basket_count'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}

export function moveToHeatmap (params, force) {
  const url = '/jam/move_to_heatmap'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}

export function moveToJam (params, force) {
  const url = '/jam/move_heatmap_to_jam'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}
